import { render } from "./ModalInboundItemsFormDetail.vue?vue&type=template&id=5a91b10c"
import script from "./ModalInboundItemsFormDetail.vue?vue&type=script&lang=js"
export * from "./ModalInboundItemsFormDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__